Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PctyListColumn = require('./PctyListColumn');

var _PctyListColumn2 = _interopRequireDefault(_PctyListColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PctyListFooterColumn = function PctyListFooterColumn(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ['children']);

  var otherProps = other;
  otherProps.className = ((other.className || '') + ' pcty-list-footer').trim();

  return _react2.default.createElement(
    _PctyListColumn2.default,
    otherProps,
    children
  );
};

PctyListFooterColumn.propTypes = {
  children: _propTypes2.default.node.isRequired
  /** INCLUDE OTHER */
};

exports.default = PctyListFooterColumn;